export const DEFAULT_BUTTON_LINK_TYPE = 'link';
export const DEFAULT_BUTTON_GENERATE_LINK = 'generate-link';
export const DEFAULT_BUTTON_ACTION_MENU = 'action-menu';
export const DEFAULT_BUTTON_CHANGE_PAGE_STATUS = 'change-page-status';
